<template>
  <div>
    <escenario-opcion-componente :nombre="$t('uso')" :descripcion="$t('uso_descrip')">
      <template v-slot:seleccion>
        <escenario-seleccion-componente
            :escenario="escenario"
            campo-id="codigo"
            campo-nombre="nombre"
            campo-descripcion="explicacion"
            :opciones="usos"
            propiedad="usoExterior"
            descripcion="Seleccionar uso"
            @change="seleccionarUso">
        </escenario-seleccion-componente>
      </template>
    </escenario-opcion-componente>

    <escenario-opcion-componente :nombre="$t('zona')" :descripcion="$t('zona_descrip')">
      <template v-slot:seleccion>
        <escenario-seleccion-componente
            :escenario="escenario"
            campo-id="codigo"
            campo-nombre="nombre"
            campo-descripcion="explicacion"
            :opciones="zonas"
            propiedad="tipoZonaExterior"
            descripcion="Seleccionar zona"
            @change="seleccionarZona">
        </escenario-seleccion-componente>
      </template>
    </escenario-opcion-componente>

    <escenario-opcion-componente :nombre="$t('soporte')" :descripcion="$t('soporte_descrip')">
      <template v-slot:seleccion>
        <escenario-seleccion-componente
            :escenario="escenario"
            campo-id="codigo"
            campo-nombre="nombre"
            campo-descripcion="explicacion"
            :opciones="soportes"
            propiedad="tipoSoporteExterior"
            descripcion="Seleccionar soporte"
            @change="seleccionarSoporte">
        </escenario-seleccion-componente>
      </template>
    </escenario-opcion-componente>

    <escenario-opcion-componente :nombre="$t('helada')" :descripcion="$t('helada_descrip')">
      <template v-slot:seleccion>
        <escenario-seleccion-componente
            :escenario="escenario"
            campo-id="codigo"
            campo-nombre="nombre"
            campo-descripcion="explicacion"
            :opciones="rHeladas"
            propiedad="riesgoHeladaExterior"
            descripcion="Seleccionar riesgo helada"
            @change="seleccionarRHelada">
        </escenario-seleccion-componente>
      </template>
    </escenario-opcion-componente>

    <escenario-opcion-componente :nombre="$t('mant')" :descripcion="$t('mant_descrip')">
      <template v-slot:seleccion>
        <div class="font-italic font-weight-bold pa-2 caption" v-if="escenario && escenario.usoExterior == null">
          {{ $t('selec_uso_antes') }}
        </div>
        <escenario-seleccion-componente
            v-if="escenario && escenario.usoExterior != null"
            :escenario="escenario"
            campo-id="codigo"
            campo-nombre="nombre"
            campo-descripcion="explicacion"
            :opciones="frecuenciasMantenimientoSeleccion"
            propiedad="frecMantExterior"
            descripcion="Seleccionar frecuencia mantenimiento"
            @change="seleccionarFrecuenciaMantenimiento">
        </escenario-seleccion-componente>
      </template>
    </escenario-opcion-componente>
  </div>
</template>

<script>
import {HttpHelper} from "../../../../../comunes/helpers/HttpHelper";
import EscenarioSeleccionComponente from "./Componentes/EscenarioSeleccionComponente";
import EscenarioOpcionComponente from "./Componentes/EscenarioOpcionComponente";

export default {
  name: "EscenarioVerticalRehabilitacion",
  model: {
    prop: 'correcto',
    event: 'change'
  },
  components: {
    EscenarioSeleccionComponente,
    EscenarioOpcionComponente
  },
  props: {
    escenario: {type: Object, required: true},
    correcto: {type: Boolean, default: false}
  },
  data: function () {
    return {
      usos: [],
      zonas: [],
      soportes: [],
      rHeladas: [],
      frecuenciasMantenimiento: [],
      frecuenciasMantenimientoSeleccion: [],
      frecuenciasMantenimientoActivadas: [],
    }
  },
  mounted() {
    let promises = [];
    promises.push(this.obtenerUsos());
    promises.push(this.obtenerZonas());
    promises.push(this.obtenerSoportes());
    promises.push(this.obtenerRHeladas());
    promises.push(this.obtenerFrecuenciasMantenimiento());

    Promise.all(promises).then(() => {
      this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
    });
  },
  watch: {
    escenario: {
      handler(val) {
        this.emitirCorrecto(this.escenarioEsCorrecto(val));
      },
      deep: true
    }
  },
  methods: {
    obtenerUsos() {
      return new Promise(resolve => {
        HttpHelper.get("exterior/uso")
            .then(data => {
              this.usos = data;
              resolve();
            });
      });
    },
    obtenerZonas() {
      return new Promise(resolve => {
        HttpHelper.get("exterior/zona")
            .then(data => {
              this.zonas = data;
              resolve();
            });
      });
    },
    obtenerSoportes() {
      return new Promise(resolve => {
        HttpHelper.get("exterior/soporte")
            .then(data => {
              this.soportes = data;
              resolve();
            });
      });
    },
    obtenerRHeladas() {
      return new Promise(resolve => {
        HttpHelper.get("exterior/helada")
            .then(data => {
              this.rHeladas = data;
              resolve();
            });
      });
    },
    obtenerFrecuenciasMantenimiento() {
      return new Promise(resolve => {
        HttpHelper.get("exterior/frecuencia-mantenimiento")
            .then(data => {
              this.frecuenciasMantenimiento = data;
              resolve();
              this.obtenerFrecuenciasMantenimientoActivadas();
            });
      });
    },
    obtenerFrecuenciasMantenimientoActivadas() {
      return new Promise(resolve => {
        this.frecuenciasMantenimientoActivadas = [];

        if (this.escenario && this.escenario.usoExterior == null) resolve();

        HttpHelper.get(`exterior/frecuencia-mantenimiento/por-uso/${this.escenario.usoExterior.codigo}`)
            .then(data => {
              data.forEach((type) => this.frecuenciasMantenimientoActivadas.push(type.codigo));
              this.frecuenciasMantenimientoSeleccion = [];
              this.frecuenciasMantenimiento.forEach((fm) => {
                if (this.frecuenciasMantenimientoActivadas.includes(fm.codigo))
                  this.frecuenciasMantenimientoSeleccion.push(fm);
              });
              if (this.escenario.frecMantExterior != null &&
                  !this.frecuenciasMantenimientoActivadas.includes(this.escenario.frecMantExterior.codigo))
                this.escenario.frecMantExterior = null;
              resolve();
              if (this.escenario.frecMantExterior != null)
                this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
            });
      });
    },
    seleccionarUso(item) {
      this.escenario.usoExterior = item;
      this.obtenerFrecuenciasMantenimientoActivadas();
    },
    seleccionarZona(item) {
      this.escenario.tipoZonaExterior = item;
    },
    seleccionarSoporte(item) {
      this.escenario.tipoSoporteExterior = item;
    },
    seleccionarRHelada(item) {
      this.escenario.riesgoHeladaExterior = item;
    },
    seleccionarFrecuenciaMantenimiento(item) {
      if (!this.frecuenciasMantenimientoActivadas.includes(item.codigo)) return;
      this.escenario.frecMantExterior = item;
    },
    emitirCorrecto(value) {
      this.$emit('change', value);
    },
    escenarioEsCorrecto(escenario) {
      let params = [
        escenario.usoExterior,
        escenario.tipoZonaExterior,
        escenario.tipoSoporteExterior,
        escenario.riesgoHeladaExterior,
        escenario.frecMantExterior
      ];

      let someNull = false;
      params.forEach((item) => {
        if (item == null) someNull = true;
      });
      if (someNull) return false;

      if (!escenario.frecMantExterior ||
          !this.frecuenciasMantenimientoActivadas.includes(escenario.frecMantExterior.codigo))
        return false;

      return true;
    },
  }
}
</script>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "uso": "Uso",
    "uso_descrip": "Dependiendo del uso se asignarán diferentes frecuencias de mantenimiento.",
    "zona": "Tipo de zona",
    "zona_descrip": "Identifica si existen necesidades especiales de seguridad debido a la presencia de humedad. Repercute además en otros requerimientos prestacionales.",
    "soporte": "Tipo de soporte",
    "soporte_descrip": "Especifica el sustrato sobre el que se asienta el pavimento.",
    "helada": "Riesgo de helada",
    "helada_descrip": "En aquellos casos en los que se prevean heladas será necesario indicarlos ya que afectará a las subcapas del pavimento urbano.",
    "mant": "Frecuencia de mantenimiento",
    "mant_descrip": "Engloba las operaciones de limpieza, reparación y sustitución del pavimento.",
    "selec_uso_antes": "Se debe seleccionar antes el uso."
  }
}
</i18n>
<!-- @formatter:on -->